import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';

import { User }     from '../user/user';
import { Api }      from '../api/api';
import { Utils }    from '../utils/utils';
import { IPTV }     from '../iptv/iptv';
import { Deeplink } from '../deeplink/deeplink';


/*
*
*  Fav (Favorite but the name is already taken by page) Provider
*
*/

@Injectable()
export class Fav {

    public data: any = [];
    public empty : boolean;
    public isLoading : boolean = false;

    constructor(
        public events: Events,
        public user: User,
        public api: Api,
        public IPTV: IPTV,
        public utils: Utils,
        public deepLink: Deeplink
    ) {
        this.events.subscribe('app:refresh', (params : any = {}) => { 
            this.fetch(true, true);
        });

        this.events.subscribe('favorite:refreshCache', (params : any = {}) => { 
            this.fetch(true, true);
        });
    }

    getFavorites(writeCache:boolean=false) {
        return new Promise((resolve, reject) => {
            this.api.getCached('iptv/favorite', { writeCache:writeCache }).subscribe((response:any)=>{
                resolve(response.result.result);
            },(err) => {
                reject(this.api.reject(err));
            });
       });
    }

    fetch(noLoading:boolean=false, writeCache:boolean=false) {
        if(!noLoading) this.isLoading = true;
        if(!noLoading) this.utils.load();
        this.getFavorites(writeCache).then((data : any = []) => {

            if (data.length) {
                let response  = data;
                for (let fav of response) {
                    for (let box of this.IPTV.boxs) {
                        if (parseInt(box.id_box) == parseInt(fav.id_box)) {
                            fav.box_name = box.name;
                        }
                    }
                }

                this.data   = this.setChannelsArrayCategories(response);
                this.empty = false;
            } else {
                this.empty = true;
            }

            if(!noLoading) this.isLoading = false;
            if(!noLoading) this.utils.unload();
        }, (err) => {});
    }

    fetchPromise() {
        return new Promise((resolve, reject) => {
            this.getFavorites(true).then((data : any = []) => {
                if (data.length) {
                    let response  = data;
                    for (let fav of response) {
                        for (let box of this.IPTV.boxs) {
                            if (parseInt(box.id_box) == parseInt(fav.id_box)) {
                                fav.box_name = box.name;
                            }
                        }
                    }
    
                    this.data   = this.setChannelsArrayCategories(response);
                    this.empty = false;

                } else {
                    this.empty = true;
                }
    
                resolve();
            }, (err) => {
                reject(err);
            });
        });
    }

    setChannelsArrayCategories(array) {
        var newArray = [];

        for(let item of array) {


            if (!this.deepLink.disableSourceChange || (
                this.deepLink.disableSourceChange && item.id_box == this.IPTV.box.id_box
            )) {

                var append = false;
 
                newArray.forEach((x, i) => {
                    if (x.id == item.id_category) {
                        newArray[i].channels.push(item);
                        append = true;
                    }
                });
 
                if (!append) {
                    newArray.push({
                        id       : item.id_category,
                        name     : item.category_name,
                        channels : [item]
                    });
                }
            }
        }

        newArray.sort(function(a, b){
            if(a.name < b.name) { return -1; }
            if(a.name > b.name) { return 1; }
            return 0;
        })

        return newArray;

    }


    

    remote (item) {

        if (item.box_name == this.IPTV.box.name) {
            this.remoteOrCast(item);
        } else {

            let boxID = 0;

            for (let box of this.IPTV.boxs) {
                if (box.name == item.box_name) boxID = box.id;
            }

            
            this.changeBox(boxID).then(() => {
                this.remoteOrCast(item);
            }, (err) => {
                if (err) this.utils.error(err);
            });    
        }
    }

    remoteOrCast(item)
    {
        if (this.IPTV.box.manufacturer == 'CHROMECAST' ) {
            this.IPTV.cast('',item.parameter, item.name, item.type_name);
        } else {
            this.IPTV.remote(item.parameter, {label:item.name});
        }

    }

    changeBox(boxID) {

        return new Promise((resolve, reject) => {

            this.events.publish('live:loading');
            this.IPTV.setSource(boxID).then(() => {
                this.events.publish('live:success');
                this.events.publish('app:refresh');
                resolve();
            }, (err) => {
                this.events.publish('live:error');
                reject();
            });

        });
    }

    toggle(channel) {
        if (channel.fav) {
            this.delete(channel);
        } else {
            this.add(channel);
        }
    }

    add(channel) {
         let that = this;
        this.utils.confirm({message: 'Add '+channel.name+' to favorite ?'}, function() {
            that.utils.load();

            that.api.post('iptv/favorite/'+channel.id).subscribe((response:any)=>{
                
                that.fetchPromise().then((data : any = []) => {
                    that.events.publish('favorite:refresh');
                    setTimeout(function() {
                        that.utils.success('Successfuly added to your favorite');
                        channel.fav = true;
                        that.utils.unload();
                    }, 500);
                });

                
            },(err) => {
                that.utils.error(this.api.reject(err));
                that.utils.unload();
            });


        });
    }

    delete(channel) {

        
        let that = this;
        this.utils.confirm({message: 'Remove '+channel.name+' from favorite ?'}, function() {
            
            that.utils.load();
            that.api.delete('iptv/favorite/'+channel.id).subscribe((response:any)=>{    


                that.fetchPromise().then((data : any = []) => {
                    that.events.publish('favorite:refresh');
                    setTimeout(function() {
                        that.utils.success('Successfuly removed from your favorite');
                        that.utils.unload();
                    }, 500);
                });
                
               
            },(err) => {
                that.utils.error(this.api.reject(err));
                
            });
        }, function() {
            that.utils.unload();
        });
        
    }

}


// WEBPACK FOOTER //
// ./src/providers/fav/fav.ts